import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import {
	Grid,
	withStyles,
	FormGroup,
	FormLabel,
	FormControlLabel,
	Radio,
} from '@material-ui/core'
import { toggleDateRange, handleFieldChange } from 'actions/campaign/addOrEdit'
import { createOrUpdateCampaign } from 'actions/campaign'
import DateTimePicker from 'components/theme/DateTimePicker'
import DateHelperText from './DateHelperText'
// import StatusText from '../StatusText'
import language from 'utils/vast-languagepack'
import moment from 'moment'

const styles = (theme) => ({
	formLabel: {
		marginRight: 5,
		fontSize: '0.875rem',
		color: '#000',
		'@media (min-width: 1617px)': {
			paddingTop: 15,
		},
	},
	radios: {
		[theme.breakpoints.down('md')]: {
			marginTop: '-16px',
		},
	},
	formControlLabelRoot: {
		marginLeft: 0,
		marginRight: 5,
	},
	radioRoot: {
		padding: '12px 2px',
	},
	textField: {
		backgroundColor: '#fff',
		width: '100%',
		borderRadius: 35,
		padding: 9,
		height: 48,
		borderWidth: 1,
		border: 'solid #707070',
	},
	input: {
		fontSize: 20,
		borderWidth: 0,
		width: '100%',
		'&:focus': {
			outline: 'none',
		},
	},
	description: {
		borderRadius: 35,
		border: 'solid #707070',
		borderWidth: 1,
		width: '100%',
		padding: 10,
	},
	textarea: {
		fontSize: 14,
		width: '100%',
		borderWidth: 0,
		resize: 'none',
		minHeight: 115,
		'&:focus': {
			outline: 'none',
		},
	},
	status: {
		textAlign: 'right',
		padding: '0 12px',
		width: '100%',
		[theme.breakpoints.down('sm')]: {
			marginTop: 10,
		},
	},
	statusText: {
		fontSize: 11,
	},
})

const Name = withRouter(
  connect(
    state => ({
      value: state.campaign.addOrEdit.campaign.fields.name,
      campaignID: state.campaign.addOrEdit.campaign.id,
      status: state.campaign.addOrEdit.campaign.status,
    }),
    dispatch =>
      bindActionCreators(
        {
          handleChange: value => handleFieldChange({ name: 'name', value }),
          createOrUpdateCampaign,
        },
        dispatch,
      ),
  )(
    withStyles(styles)(
      class NameComponent extends Component {
        constructor(props) {
          super(props)

          this.state = {
            typing: false,
            value: props.value,
          }
        }

        componentDidUpdate(prevProps) {
          if (prevProps?.value !== this.props.value && !prevProps.value) {
            this.setState({ value: this.props.value })
          }
        }

        handleChange = value => {
          clearTimeout(this.timeout)
          this.setState({ value })
          if (value) {
            this.setState({ typing: true })
            this.timeout = setTimeout(() => {
              this.props.handleChange(value)
              this.props.createOrUpdateCampaign().then(payload => {
                if (
                  this.props.history.location.pathname.slice(0, 14) ===
                  '/campaigns/new'
                ) {
                  this.props.history.replace(`/campaigns/${payload.id}`)
                }
              })
              this.setState({ typing: false })
            }, 500)
          }
        }

        render() {
          return (
            <div className={this.props.classes.textField}>
              <input
                value={this.state.value}
                onChange={e => this.handleChange(e.target.value)}
                className={this.props.classes.input}
                type="text"
                placeholder={language.campaign.helperText.campaignName}
                disabled={
                  this.props.status === 'L' || this.props.status === 'C'
                }
              />
            </div>
          )
        }
      },
    ),
  ),
)

const Description = connect(
  state => ({
    value: state.campaign.addOrEdit.campaign.fields.description,
    status: state.campaign.addOrEdit.campaign.status,
  }),
  dispatch =>
    bindActionCreators(
      {
        handleChange: value =>
          handleFieldChange({ name: 'description', value }),
        createOrUpdateCampaign,
      },
      dispatch,
    ),
)(
  withStyles(styles)(
    class DescriptionComponent extends Component {
      constructor(props) {
        super(props)

        this.state = {
          typing: false,
          value: props.value,
        }
      }

      componentDidUpdate(prevProps) {
        if (prevProps?.value !== this.props.value && !prevProps.value) {
          this.setState({ value: this.props.value })
        }
      }

      handleChange = value => {
        clearTimeout(this.timeout)
        this.setState({ typing: true, value })
        this.timeout = setTimeout(() => {
          this.props.handleChange(value)
          this.props.createOrUpdateCampaign()
          this.setState({ typing: false })
        }, 500)
      }

      render() {
        return (
          <div className={this.props.classes.description}>
            <textarea
              className={this.props.classes.textarea}
              value={this.state.value}
              onChange={e => this.handleChange(e.target.value)}
              placeholder={language.campaign.helperText.campaignDescription}
              disabled={this.props.status === 'L' || this.props.status === 'C'}
            />
          </div>
        )
      }
    },
  ),
)

const DateRangeToggle = connect(
	(state) => ({
		value: state.campaign.addOrEdit.campaign.dateRange,
		status: state.campaign.addOrEdit.campaign.status,
	}),
	(dispatch) => bindActionCreators({ toggleDateRange }, dispatch),
)(
	withStyles(styles)(({ classes, value, toggleDateRange, status }) => (
		<FormGroup row>
			<FormLabel className={classes.formLabel} component="legend">
				{language.campaign.add.campaignDateRange}
			</FormLabel>
			<div className={classes.radios}>
				<FormControlLabel
					classes={{ root: classes.formControlLabelRoot }}
					control={
						<Radio
							classes={{ root: classes.radioRoot }}
							checked={value}
							value={'true'}
							onChange={(e) => toggleDateRange(e.target.value)}
							disabled={status === 'L' || status === 'C'}
						/>
					}
					label="Yes"
					disabled={status === 'L' || status === 'C'}
				/>
				<FormControlLabel
					classes={{ root: classes.formControlLabelRoot }}
					control={
						<Radio
							classes={{ root: classes.radioRoot }}
							checked={!value}
							value={'false'}
							onChange={(e) => toggleDateRange(e.target.value)}
							disabled={status === 'L' || status === 'C'}
						/>
					}
					label="No"
					disabled={status === 'L' || status === 'C'}
				/>
			</div>
		</FormGroup>
	)),
)

const StartDate = connect(
	(state) => ({
		display: state.campaign.addOrEdit.campaign.dateRange ? 'block' : 'none',
		value: state.campaign.addOrEdit.campaign.fields.start_date,
		status: state.campaign.addOrEdit.campaign.status,
	}),
	(dispatch) =>
		bindActionCreators(
			{
				handleChange: (value) =>
					handleFieldChange({ name: 'start_date', value }),
				createOrUpdateCampaign,
			},
			dispatch,
		),
)(
	withStyles(styles)(
		class StartDateComponent extends Component {
			state = {
				typing: false,
				// newValue: null,
			}

			handleChange = (value) => {
				let newValue = value
				if (moment(value).isSame(Date.now(), 'day')) {
					newValue = Date.now()
				}
				if (newValue >= Date.now() || !newValue) {
					clearTimeout(this.timeout)
					this.props.handleChange(newValue)
					this.setState({ typing: true })
					this.timeout = setTimeout(() => {
						this.props.createOrUpdateCampaign()
						this.setState({ typing: false })
					}, 500)
				} else {
					this.forceUpdate()
				}
			}

			render() {
				return (
					<DateTimePicker
						value={this.props.value}
						handleChange={this.handleChange}
						style={{
							display: this.props.display,
						}}
						title={language.campaign.labels.startDate}
						fontSizeSmall
						noMin={!this.state.newValue}
						noHelperText
						disabled={this.props.status === 'L' || this.props.status === 'C'}
					/>
				)
			}
		},
	),
)

const EndDate = connect(
	(state) => ({
		display: state.campaign.addOrEdit.campaign.dateRange ? 'block' : 'none',
		value: state.campaign.addOrEdit.campaign.fields.end_date,
		status: state.campaign.addOrEdit.campaign.status,
	}),
	(dispatch) =>
		bindActionCreators(
			{
				handleChange: (value) => handleFieldChange({ name: 'end_date', value }),
				createOrUpdateCampaign,
			},
			dispatch,
		),
)(
	withStyles(styles)(
		class EndDateComponent extends Component {
			state = {
				typing: false,
			}

			handleChange = (value) => {
				let newValue = value
				if (moment(value).isSame(Date.now(), 'day')) {
					newValue = Date.now()
				}
				if (newValue >= Date.now() || !newValue) {
					clearTimeout(this.timeout)
					this.props.handleChange(newValue)
					this.setState({ typing: true })
					this.timeout = setTimeout(() => {
						this.props.createOrUpdateCampaign()
						this.setState({ typing: false })
					}, 500)
				} else {
					this.forceUpdate()
				}
			}

			render() {
				return (
					<DateTimePicker
						value={this.props.value}
						handleChange={this.handleChange}
						style={{
							display: this.props.display,
						}}
						title={language.campaign.labels.endDate}
						fontSizeSmall
						noMin
						noHelperText
						disabled={this.props.status === 'L' || this.props.status === 'C'}
					/>
				)
			}
		},
	),
)

// const Status = withStyles(styles)(({ classes }) => (
//   <div className={classes.status}>
//     <StatusText classes={classes} />
//   </div>
// ))

export default ({ style }) => (
	<Grid style={style || null} container spacing={24}>
		{/* <Status /> */}
		<Grid item xs={12}>
			<Name />
		</Grid>
		<Grid item xs={12}>
			<Description />
		</Grid>
		<Grid item xs={12}>
			<Grid container spacing={8}>
				<Grid item xs={12}>
					<DateRangeToggle />
				</Grid>
				<Grid item xs={12}>
					<Grid container spacing={8}>
						<Grid item xs={12}>
							<StartDate />
						</Grid>
						<Grid item xs={12}>
							<EndDate />
						</Grid>
					</Grid>
				</Grid>
				<Grid item xs={12}>
					<DateHelperText />
				</Grid>
			</Grid>
		</Grid>
	</Grid>
)
